import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SparkAttribute, SingleSparkResponse } from 'types/Spark/Spark';

type mutationVariables = Pick<SparkAttribute, 'deletedAt' | 'isDeleted'>;

export function useDeleteSpark(sparkID: string | undefined | null) {
  const queryClient = useQueryClient();

  const deleteSpark = (updatedSpark: mutationVariables) => {
    if (!sparkID) {
      Promise.reject('sparkID ID can not be null');
    }

    const body = {
      data: {
        id: sparkID,
        type: 'sparks',
        attributes: updatedSpark,
      },
    };

    return fetchWrapper<SingleSparkResponse>({
      url: `Sparks/${sparkID}`,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation('deleteSpark', deleteSpark, {
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['sparks', sparkID] });
      queryClient.invalidateQueries(['sparks']);
      toastr.success('Spark Deleted');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to delete Spark: ${error.message}`);
      }
    },
  });
}
